import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import { Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Credenciales inválidas');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-grid" />
      <div className="login-card">
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <img
            src="/logo_cdm.svg"
            alt="Centro de Monitoreo"
            style={{ width:'100%', maxWidth:260, height:'auto', margin:'0 auto', display:'block' }}
            onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }}
          />
          {/* Fallback */}
          <div style={{ display:'none' }}>
            <div style={{ fontFamily:'var(--font-display)', fontSize:26, fontWeight:700, letterSpacing:2, textTransform:'uppercase', color:'var(--accent)' }}>
              Centro de Monitoreo
            </div>
          </div>
          <div style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-mono)', letterSpacing:2, marginTop:12 }}>
            ACCESO AL SISTEMA
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Correo Electrónico</label>
            <input className="form-control" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="usuario@empresa.com" required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Contraseña</label>
            <div style={{ position:'relative' }}>
              <input className="form-control" type={showPass ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required style={{ paddingRight:40 }} />
              <button type="button" onClick={() => setShowPass(!showPass)} style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer' }}>
                {showPass ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width:'100%', justifyContent:'center', marginTop:8 }}>
            {loading ? <span className="spinner" style={{ width:16, height:16 }} /> : 'Ingresar al Sistema'}
          </button>
        </form>
      </div>
    </div>
  );
}
